<div
  class="cfc-common-bottom-panel"
  [style]="'transition: ' + showTransitionOptions + 's'"
  [ngStyle]="{
    opacity : visible ? 1 : 0,
    transform: !visible ? 'translateY(100%)' : reachBottom ? 'translateY(-'+ getFooterHeight +'px)' : 'translateY(0%)'}"
  [ngClass]="styleClass"
>
  <div class="cfc-common-bottom-panel-wrapper">
    <ng-content></ng-content>
  </div>
</div>
